<template>
  <div class="gift-wrap form-group">
    <div className="checkbox">
      <input
        id="checkbox-2"
        className="checkbox__input"
        :checked="cartGiftWrap"
        :disabled="state !== 'ready'"
        type="checkbox"
        @change="onChange"
      >
      <label
        className="checkbox__label gift-wrap__label
          text-utility-capitalized-m-desktop text-utility-capitalized-s"
        htmlFor="checkbox-2"
      >{{ $string(
        'cart.gift_card.checkbox_label',
        { replace: { value: $formatMoney(product.price.amount) } }
      ) }}</label>
    </div>
    <div
      v-if="cartGiftWrap"
      className="form-group__field gift-wrap__message"
    >
      <label
        className="form-group__label text-utility-label-s"
        htmlFor="textarea"
      >{{ $string('cart.gift_card.message_label') }}</label>
      <textarea
        id="textarea"
        v-model="message"
        class="text-body-m"
        name="attributes[gift-wrapping-note]"
        :maxlength="$variable('settings.giftWrap.characterLimit')"
        :placeholder="$string('cart.gift_card.message_placeholder')"
        @blur="changeAttribute"
      />
      <p
        class="gift-wrap__message--info text-body-s"
        v-text="$string(
          'cart.gift_card.character_limit',
          { replace: {
            limit: $variable('settings.giftWrap.characterLimit'),
            value: message.length,
          } }
        )"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Gift wrap (gift-wrap)
 * -----------------------------------------------------------------------------
 * Gift wrap item to be used in cart page.
 *
 */
import { mapActions, mapState } from 'vuex'

export default {
  name: 'GiftWrap',

  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      state: 'loading',
      message: '',
    }
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      cart: (state) => state.cart.response,
      cartStatus: (state) => state.cart.status,
    }),

    /**
     * Returns gift wrap line item if in cart.
     * @return {Object|Boolean}
     */
    cartGiftWrap() {
      return this.cart.items.find((item) => {
        return item.id === this.product?.variants[0]?.id
      }) || false
    },
  },

  watch: {

    /**
   * Watch cart status items to see if item is being updated.
   */
    'cartStatus.items'() {
      if (this.cartStatus.items.includes(this.product?.id)) {
        this.state = 'updating'
        return
      }

      this.state = 'ready'
    },
  },

  mounted() {
    this.state = 'ready'
    this.message = this.cart?.attributes['gift-wrapping-note'] || ''
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      addItem: 'cart/addItem',
      removeItem: 'cart/updateItem',
      updateCartAttributes: 'cart/updateCartAttributes',
    }),

    /**
     * Watch change to update cart.
     */
    onChange() {
      if (this.cartGiftWrap) {
        this.removeItem(this.cartGiftWrap.key)
        return
      }

      this.addItem([
        {
          id: this.product?.variants[0]?.id,
          quantity: 1,
        },
      ])
    },

    changeAttribute(event) {
      const message = event.target.value

      this.updateCartAttributes({ attributes: { 'gift-wrapping-note': message } })
    },
  },
}
</script>

<style lang="scss">
@import './gift-wrap';
</style>
